import RefClient from 'ref-client-core';
import MatrixResResultPlugin from './matrixResResultPlugin';
import matrixResultPlugin from './matrixResultPlugin';

RefClient.formViewsPlugin.register('matrixResult', matrixResultPlugin);

RefClient.resultPanelPlugin.register('matrixResult', MatrixResResultPlugin);
